import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import EmployeeProcessService from '../services/EmployeeProcessService';
import LeaveProcessService from '../services/LeaveProcessService';
import { useLoading } from '../Utils/LoadingContext';

function LeaveUpload() {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const { setLoading } = useLoading();

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const downloadExcel = (data, fileName = "LeaveUploadResult.xlsx") => {
        if (!data || data.length === 0) return;

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Result");

        XLSX.writeFile(workbook, fileName);
    };

    const handleUpload = async (e) => {
        e.preventDefault();

        if (!file) {
            alert("Please select file");
            return;
        }

        if (!window.confirm("Upload Leave Data?")) return;

        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("employeeMode", 0); // ✅ REQUIRED

        try {
            setLoading(true);
            setUploading(true);
            debugger;
            const response = await LeaveProcessService.uploadLeave(formData);

            if (response.success && response.data.statusCode === 200) {
                downloadExcel(response.data.result);
            } else {
                alert(response.data.message);
            }
        } catch (err) {
            toast.error("Upload failed");
        } finally {
            setUploading(false);
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleUpload} className="upload-form">
            <div className="row">
                <div className="col-12 mb-3 border-bottom pb-2">
                    <h4 className="text-left text-primary">Leave Upload</h4>
                    <button
                        type="button"
                        onClick={async () => {
                            const success = await EmployeeProcessService.getTemplate("LeaveUpload.xlsx");
                            if (success) {
                                alert("Template downloaded successfully.", "success");
                            }
                        }}
                        className="btn btn-outline-success"
                    >
                        Download Template
                    </button>
                </div>

                <div className="form-group col-md-4">
                    <label>File</label>
                    <input type="file" onChange={handleFileChange} />
                </div>
                <div className="form-group mt-4 col-md-2">
                    <button type="submit" disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload"}
                    </button>
                </div>
            </div>
        </form>
    );
}

export default LeaveUpload;